/* Aveline theme script — no dependencies */
(function () {
  'use strict';

  var theme = window.theme || {};
  theme.routes = theme.routes || {};
  theme.strings = theme.strings || {};

  var $ = function (selector, context) { return (context || document).querySelector(selector); };
  var $$ = function (selector, context) { return Array.prototype.slice.call((context || document).querySelectorAll(selector)); };
  var mqSmall = window.matchMedia('(max-width: 768px)');

  function debounce(fn, wait) {
    var timer;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(ctx, args); }, wait || 200);
    };
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = String(format || theme.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, decimals, thousands, decimal) {
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var fixed = (number / 100).toFixed(decimals);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(placeholder);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = fmt(cents, 2, ' ', '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(placeholder, value);
  }
  theme.formatMoney = formatMoney;

  function resizeImage(src, width) {
    if (!src) return '';
    try {
      var url = new URL(src, window.location.origin);
      url.searchParams.set('width', width);
      return url.toString();
    } catch (e) {
      return src;
    }
  }

  var icons = {
    minus: '<svg class="icon icon--minus" aria-hidden="true" focusable="false" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 10h14"/></svg>',
    plus: '<svg class="icon icon--plus" aria-hidden="true" focusable="false" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M10 3v14M3 10h14"/></svg>'
  };

  /* ------------------------------------------------------------------
     Layers: drawers, modals, search overlay
     ------------------------------------------------------------------ */
  var overlay = null;
  var lastTrigger = null;

  function lockScroll(lock) {
    document.documentElement.classList.toggle('scroll-lock', !!lock);
  }

  function openLayer(id, trigger) {
    var el = document.getElementById(id);
    if (!el) return false;
    closeLayers(true);
    overlay = overlay || $('[data-page-overlay]');
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (el.classList.contains('drawer') || el.classList.contains('search-modal')) {
      if (overlay) overlay.classList.add('is-visible');
    }
    if (!el.classList.contains('search-modal')) lockScroll(true);
    lastTrigger = trigger || document.activeElement;
    var focusTarget = $('[data-autofocus]', el) || $('button, a[href], input', el);
    if (focusTarget) setTimeout(function () { focusTarget.focus({ preventScroll: true }); }, 60);
    return true;
  }

  function closeLayers(silent) {
    var open = $$('.drawer.is-open, .modal.is-open, .search-modal.is-open');
    open.forEach(function (el) {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
    });
    overlay = overlay || $('[data-page-overlay]');
    if (overlay) overlay.classList.remove('is-visible');
    lockScroll(false);
    if (!silent && open.length && lastTrigger && document.body.contains(lastTrigger)) {
      lastTrigger.focus({ preventScroll: true });
    }
  }
  theme.openLayer = openLayer;
  theme.closeLayers = closeLayers;

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-open]');
    if (opener) {
      var id = opener.getAttribute('data-open');
      if (id === 'cart-drawer' && theme.cartType === 'page') return;
      if (openLayer(id, opener)) event.preventDefault();
      return;
    }
    if (event.target.closest('[data-close]') || event.target.matches('[data-page-overlay]') || event.target.classList.contains('modal')) {
      event.preventDefault();
      closeLayers();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeLayers();
    $$('[data-lightbox].is-open').forEach(function (lightbox) {
      var section = lightbox.closest('[data-product-section]');
      if (section && section._product) section._product.closeLightbox();
    });
  });

  /* ------------------------------------------------------------------
     Announcement bar
     ------------------------------------------------------------------ */
  function initAnnouncements(root) {
    $$('[data-announcement-bar]', root).forEach(function (bar) {
      if (bar._init) return;
      bar._init = true;
      var items = $$('[data-announcement-item]', bar);
      if (items.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var index = 0;
      var speed = (parseInt(bar.getAttribute('data-speed'), 10) || 5) * 1000;
      bar._timer = setInterval(function () {
        items[index].classList.remove('is-active');
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');
      }, speed);
    });
  }

  /* ------------------------------------------------------------------
     Predictive search
     ------------------------------------------------------------------ */
  function initSearch(root) {
    $$('[data-predictive-search]', root).forEach(function (form) {
      if (form._init) return;
      form._init = true;
      var input = $('input[name="q"]', form);
      var modal = form.closest('[data-search-modal]');
      var results = $('[data-predictive-results]', modal || form);
      if (!input || !results || !theme.routes.predictiveSearch) return;

      var run = debounce(function () {
        var query = input.value.trim();
        if (query.length < 2) { results.innerHTML = ''; return; }
        var url = theme.routes.predictiveSearch + '.json?q=' + encodeURIComponent(query) +
          '&resources[type]=product&resources[limit]=6';
        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (response) { return response.json(); })
          .then(function (data) {
            if (input.value.trim() !== query) return;
            var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              results.innerHTML = '<p class="predictive__empty">' +
                escapeHtml((theme.strings.searchNoResults || '').replace('{{ terms }}', query)) + '</p>';
              return;
            }
            var items = products.map(function (product) {
              var image = (product.featured_image && product.featured_image.url) || product.image;
              var price = Math.round(parseFloat(product.price) * 100);
              return '<li><a class="predictive__item" href="' + escapeHtml(product.url) + '">' +
                (image ? '<img src="' + escapeHtml(resizeImage(image, 128)) + '" alt="" loading="lazy" width="64" height="64">' : '') +
                '<span><span class="predictive__title">' + escapeHtml(product.title) + '</span>' +
                '<span class="predictive__price">' + escapeHtml(formatMoney(price)) + '</span></span></a></li>';
            }).join('');
            results.innerHTML = '<p class="predictive__heading">' + escapeHtml(theme.strings.searchProducts) + '</p>' +
              '<ul class="predictive__list" role="list">' + items + '</ul>' +
              '<a class="predictive__all" href="' + escapeHtml(theme.routes.search) + '?q=' + encodeURIComponent(query) + '">' +
              escapeHtml(theme.strings.searchViewAll) + '</a>';
          })
          .catch(function () { results.innerHTML = ''; });
      }, 250);

      input.addEventListener('input', run);
    });
  }

  /* ------------------------------------------------------------------
     Cart
     ------------------------------------------------------------------ */
  var Cart = {
    fetch: function () {
      return fetch(theme.routes.cart + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); });
    },

    add: function (formData) {
      return fetch(theme.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || theme.strings.addError);
          }
          return data;
        });
      });
    },

    change: function (key, quantity) {
      return fetch(theme.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || theme.strings.addError);
          return data;
        });
      });
    },

    itemTemplate: function (item) {
      var variant = (!item.product_has_only_default_variant && item.variant_title)
        ? '<div class="cart-item__variant">' + escapeHtml(item.variant_title) + '</div>' : '';
      var plan = item.selling_plan_allocation
        ? '<div class="cart-item__variant">' + escapeHtml(item.selling_plan_allocation.selling_plan.name) + '</div>' : '';
      var discounts = (item.line_level_discount_allocations || []).map(function (allocation) {
        return '<div class="cart-item__discount">' + escapeHtml(allocation.discount_application.title) +
          ' (-' + escapeHtml(formatMoney(allocation.amount)) + ')</div>';
      }).join('');
      var original = item.original_line_price > item.final_line_price
        ? '<s>' + escapeHtml(formatMoney(item.original_line_price)) + '</s>' : '';
      return '<div class="cart-item" data-cart-item data-key="' + escapeHtml(item.key) + '">' +
        '<a class="cart-item__image" href="' + escapeHtml(item.url) + '">' +
          (item.image ? '<img src="' + escapeHtml(resizeImage(item.image, 180)) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy" width="90" height="90">' : '') +
        '</a>' +
        '<div class="cart-item__details">' +
          '<a class="cart-item__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
          variant + plan + discounts +
          '<div class="cart-item__bottom">' +
            '<div class="qty">' +
              '<button type="button" class="qty__btn" data-qty-change="-1" aria-label="' + escapeHtml(theme.strings.decrease) + '">' + icons.minus + '</button>' +
              '<input class="qty__input" type="number" inputmode="numeric" min="0" value="' + item.quantity + '" aria-label="' + escapeHtml(theme.strings.quantity) + '" data-qty-input>' +
              '<button type="button" class="qty__btn" data-qty-change="1" aria-label="' + escapeHtml(theme.strings.increase) + '">' + icons.plus + '</button>' +
            '</div>' +
            '<div class="cart-item__price">' + original + '<span>' + escapeHtml(formatMoney(item.final_line_price)) + '</span></div>' +
          '</div>' +
          '<button type="button" class="cart-item__remove" data-cart-remove>' + escapeHtml(theme.strings.remove) + '</button>' +
        '</div>' +
      '</div>';
    },

    render: function (cart) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.classList.toggle('is-hidden', cart.item_count === 0);
      });
      var drawer = document.getElementById('cart-drawer');
      if (!drawer) return;
      var body = $('[data-cart-body]', drawer);
      var footer = $('[data-cart-footer]', drawer);
      var total = $('[data-cart-total]', drawer);
      if (!cart.item_count) {
        body.innerHTML = '<p class="cart-drawer__empty">' + escapeHtml(theme.strings.cartEmpty) + '</p>';
        if (footer) footer.hidden = true;
        return;
      }
      if (footer) footer.hidden = false;
      if (total) total.textContent = formatMoney(cart.total_price);
      body.innerHTML = cart.items.map(Cart.itemTemplate).join('');
    },

    refresh: function (open) {
      return Cart.fetch().then(function (cart) {
        Cart.render(cart);
        if (open) openLayer('cart-drawer');
        return cart;
      });
    },

    updateItem: function (key, quantity) {
      var drawer = document.getElementById('cart-drawer');
      if (drawer) drawer.classList.add('is-loading');
      return Cart.change(key, quantity)
        .then(Cart.render)
        .catch(function () { return Cart.refresh(); })
        .then(function () { if (drawer) drawer.classList.remove('is-loading'); });
    }
  };
  theme.cart = Cart;

  document.addEventListener('click', function (event) {
    var drawer = event.target.closest('#cart-drawer');
    if (!drawer) return;
    var step = event.target.closest('[data-qty-change]');
    var remove = event.target.closest('[data-cart-remove]');
    var item = event.target.closest('[data-cart-item]');
    if (!item) return;
    if (step) {
      var input = $('[data-qty-input]', item);
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-change'), 10));
      Cart.updateItem(item.getAttribute('data-key'), next);
    } else if (remove) {
      Cart.updateItem(item.getAttribute('data-key'), 0);
    }
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('#cart-drawer [data-qty-input]')) return;
    var item = event.target.closest('[data-cart-item]');
    var quantity = Math.max(0, parseInt(event.target.value, 10) || 0);
    Cart.updateItem(item.getAttribute('data-key'), quantity);
  });

  /* Product forms: add with AJAX and open the drawer */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form[data-product-form]')) return;
    if (theme.cartType === 'page') return;
    event.preventDefault();

    var buttons = $$('button[type="submit"]').filter(function (button) { return button.form === form; });
    var errorEl = $('[data-form-error]', form);
    buttons.forEach(function (button) { button.classList.add('is-loading'); button.setAttribute('aria-busy', 'true'); });
    if (errorEl) errorEl.hidden = true;

    Cart.add(new FormData(form))
      .then(function () { return Cart.refresh(true); })
      .catch(function (error) {
        if (errorEl) {
          errorEl.textContent = error.message || theme.strings.addError;
          errorEl.hidden = false;
        }
      })
      .then(function () {
        buttons.forEach(function (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-busy'); });
      });
  });

  /* Quantity steppers inside product forms */
  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-qty-step]');
    if (!step) return;
    var input = $('input', step.parentElement);
    if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    input.value = Math.max(min, (parseInt(input.value, 10) || min) + parseInt(step.getAttribute('data-qty-step'), 10));
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) Cart.refresh().catch(function () {});
  });

  /* ------------------------------------------------------------------
     Product gallery
     ------------------------------------------------------------------ */
  function Gallery(el) {
    this.el = el;
    if (!el) return;
    this.slider = $('[data-gallery-slider]', el);
    this.slides = $$('[data-gallery-slide]', el);
    this.thumbs = $$('[data-gallery-thumb]', el);
    this.thumbsWrap = $('[data-gallery-thumbs]', el);
    this.dots = $$('[data-gallery-dot]', el);
    this.index = 0;
    var self = this;
    this.thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function () { self.goTo(i); }); });
    this.dots.forEach(function (dot, i) { dot.addEventListener('click', function () { self.goTo(i); }); });
    if (this.slider) {
      this.slider.addEventListener('scroll', debounce(function () { self.syncFromScroll(); }, 60), { passive: true });
    }
  }

  Gallery.prototype.goTo = function (i, instant) {
    var slide = this.slides[i];
    if (!slide || !this.slider) return;
    var left = slide.offsetLeft - (this.slider.clientWidth - slide.clientWidth) / 2;
    this.slider.scrollTo({ left: Math.max(0, left), behavior: instant ? 'auto' : 'smooth' });
    this.setActive(i);
  };

  Gallery.prototype.goToMedia = function (mediaId) {
    for (var i = 0; i < this.slides.length; i++) {
      if (String(this.slides[i].getAttribute('data-media-id')) === String(mediaId)) {
        this.goTo(i);
        return;
      }
    }
  };

  Gallery.prototype.syncFromScroll = function () {
    if (!this.slider) return;
    var center = this.slider.scrollLeft + this.slider.clientWidth / 2;
    var best = 0;
    var distance = Infinity;
    this.slides.forEach(function (slide, i) {
      var mid = slide.offsetLeft + slide.clientWidth / 2;
      var d = Math.abs(mid - center);
      if (d < distance) { distance = d; best = i; }
    });
    if (best !== this.index) this.setActive(best);
  };

  Gallery.prototype.setActive = function (i) {
    this.index = i;
    this.thumbs.forEach(function (thumb, j) {
      thumb.classList.toggle('is-active', j === i);
      if (j === i) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current');
    });
    this.dots.forEach(function (dot, j) {
      dot.classList.toggle('is-active', j === i);
      if (j === i) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
    });
    var thumb = this.thumbs[i];
    if (thumb && this.thumbsWrap) {
      var wrap = this.thumbsWrap;
      var top = thumb.offsetTop - wrap.clientHeight / 2 + thumb.clientHeight / 2;
      wrap.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
  };

  /* ------------------------------------------------------------------
     Product section
     ------------------------------------------------------------------ */
  function ProductSection(el) {
    this.el = el;
    var json = $('[data-product-json]', el);
    if (!json) return;
    try {
      this.product = JSON.parse(json.textContent);
    } catch (e) {
      return;
    }
    var inventoryEl = $('[data-inventory-json]', el);
    try {
      this.inventory = inventoryEl ? JSON.parse(inventoryEl.textContent) : {};
    } catch (e) {
      this.inventory = {};
    }
    this.form = $('form[data-product-form]', el);
    this.picker = $('[data-variant-picker]', el);
    this.groups = $$('[data-option-group]', el);
    this.gallery = new Gallery($('[data-gallery]', el));

    var self = this;
    if (this.picker) {
      this.picker.addEventListener('change', function (event) {
        if (event.target.matches('input[type="radio"]')) self.onOptionChange();
      });
      this.updateAvailability();
    }
    this.initStickyBar();
    this.initLightbox();
  }

  ProductSection.prototype.selectedOptions = function () {
    return this.groups.map(function (group) {
      var checked = $('input[type="radio"]:checked', group);
      return checked ? checked.value : null;
    });
  };

  ProductSection.prototype.findVariant = function (options) {
    return this.product.variants.find(function (variant) {
      return variant.options.every(function (value, i) { return value === options[i]; });
    });
  };

  ProductSection.prototype.onOptionChange = function () {
    var options = this.selectedOptions();
    var variant = this.findVariant(options);
    this.groups.forEach(function (group, i) {
      var label = $('[data-selected-value]', group);
      if (label) label.textContent = options[i] || '';
    });
    this.updateAvailability();
    this.applyVariant(variant);
  };

  ProductSection.prototype.updateAvailability = function () {
    var options = this.selectedOptions();
    var variants = this.product.variants;
    this.groups.forEach(function (group, index) {
      $$('input[type="radio"]', group).forEach(function (input) {
        var available = variants.some(function (variant) {
          if (variant.options[index] !== input.value || !variant.available) return false;
          for (var j = 0; j < index; j++) {
            if (variant.options[j] !== options[j]) return false;
          }
          return true;
        });
        input.classList.toggle('is-unavailable', !available);
      });
    });
  };

  ProductSection.prototype.applyVariant = function (variant) {
    this.currentVariant = variant;
    $$('[data-variant-id]', this.el).forEach(function (input) { input.value = variant ? variant.id : ''; });

    if (variant && this.el.getAttribute('data-update-url') === 'true' && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    this.updatePrice(variant);
    this.updateButtons(variant);
    this.updateLowStock(variant);
    if (variant && variant.featured_media && this.gallery) this.gallery.goToMedia(variant.featured_media.id);
    this.syncSticky(variant);
  };

  ProductSection.prototype.updatePrice = function (variant) {
    if (!variant) return;
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    $$('[data-price]', this.el).forEach(function (el) { el.textContent = formatMoney(variant.price); });
    $$('[data-compare-price]', this.el).forEach(function (el) {
      el.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      el.hidden = !onSale;
    });
    $$('[data-savings]', this.el).forEach(function (el) {
      if (!onSale) { el.hidden = true; return; }
      var style = el.getAttribute('data-style');
      var label = el.getAttribute('data-label') || '';
      var value = style === 'amount'
        ? formatMoney(variant.compare_at_price - variant.price)
        : Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%';
      el.textContent = (label + ' ' + value).trim();
      el.hidden = false;
    });
  };

  ProductSection.prototype.updateButtons = function (variant) {
    var text = !variant ? theme.strings.unavailable : (variant.available ? theme.strings.addToCart : theme.strings.soldOut);
    $$('[data-add-to-cart]', this.el).forEach(function (button) {
      button.disabled = !variant || !variant.available;
      var label = $('[data-add-to-cart-text]', button) || button;
      label.textContent = text;
    });
  };

  ProductSection.prototype.updateLowStock = function (variant) {
    var el = $('[data-low-stock]', this.el);
    if (!el) return;
    var quantity = variant ? this.inventory[variant.id] : null;
    var threshold = parseInt(el.getAttribute('data-threshold'), 10) || 0;
    var show = !!variant && variant.available && typeof quantity === 'number' && quantity > 0 && quantity <= threshold;
    el.hidden = !show;
    if (show) {
      var textEl = $('[data-low-stock-text]', el);
      if (textEl) textEl.textContent = (el.getAttribute('data-text') || '').replace('[count]', quantity);
    }
  };

  ProductSection.prototype.initStickyBar = function () {
    var bar = $('[data-sticky-atc]', this.el);
    this.sticky = bar;
    if (!bar || !('IntersectionObserver' in window)) return;
    var mainButton = this.form ? $('[data-add-to-cart]', this.form) : null;
    var self = this;

    if (mainButton) {
      this.stickyObserver = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
        if (past) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
        document.body.classList.toggle('has-sticky-atc', past);
      });
      this.stickyObserver.observe(mainButton);
    }

    $$('[data-sticky-option]', bar).forEach(function (select) {
      select.addEventListener('change', function () {
        var position = parseInt(select.getAttribute('data-sticky-option'), 10);
        var group = self.groups[position - 1];
        if (!group) return;
        var match = $$('input[type="radio"]', group).find(function (input) { return input.value === select.value; });
        if (match) {
          match.checked = true;
          self.onOptionChange();
        }
      });
    });
  };

  ProductSection.prototype.syncSticky = function (variant) {
    var bar = this.sticky;
    if (!bar) return;
    var options = this.selectedOptions();
    $$('[data-sticky-option]', bar).forEach(function (select) {
      var value = options[parseInt(select.getAttribute('data-sticky-option'), 10) - 1];
      if (value != null) select.value = value;
    });
    var image = $('[data-sticky-image]', bar);
    if (image && variant && variant.featured_image && variant.featured_image.src) {
      image.removeAttribute('srcset');
      image.src = resizeImage(variant.featured_image.src, 120);
    }
  };

  ProductSection.prototype.initLightbox = function () {
    var lightbox = $('[data-lightbox]', this.el);
    if (!lightbox) return;
    this.lightbox = lightbox;
    this.lightboxTrack = $('[data-lightbox-track]', lightbox);
    var self = this;

    this.el.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-lightbox-open]');
      if (!trigger || !self.el.contains(trigger)) return;
      event.preventDefault();
      self.openLightbox(parseInt(trigger.getAttribute('data-lightbox-open'), 10) || 0, trigger);
    });

    $('[data-lightbox-close]', lightbox).addEventListener('click', function () { self.closeLightbox(); });
    var prev = $('[data-lightbox-prev]', lightbox);
    var next = $('[data-lightbox-next]', lightbox);
    if (prev) prev.addEventListener('click', function () { self.stepLightbox(-1); });
    if (next) next.addEventListener('click', function () { self.stepLightbox(1); });
    lightbox.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') self.stepLightbox(-1);
      if (event.key === 'ArrowRight') self.stepLightbox(1);
    });
  };

  ProductSection.prototype.openLightbox = function (index, trigger) {
    var lightbox = this.lightbox;
    var track = this.lightboxTrack;
    this.lightboxTrigger = trigger;
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    window.requestAnimationFrame(function () {
      var slide = track.children[index];
      if (slide) track.scrollLeft = slide.offsetLeft;
      $('[data-lightbox-close]', lightbox).focus({ preventScroll: true });
    });
  };

  ProductSection.prototype.stepLightbox = function (direction) {
    var track = this.lightboxTrack;
    var width = track.clientWidth;
    var target = track.scrollLeft + direction * width;
    if (target < 0) target = track.scrollWidth - width;
    if (target > track.scrollWidth - width + 2) target = 0;
    track.scrollTo({ left: target, behavior: 'smooth' });
  };

  ProductSection.prototype.closeLightbox = function () {
    if (!this.lightbox || !this.lightbox.classList.contains('is-open')) return;
    this.lightbox.classList.remove('is-open');
    this.lightbox.setAttribute('aria-hidden', 'true');
    lockScroll(false);
    if (this.lightboxTrigger) this.lightboxTrigger.focus({ preventScroll: true });
  };

  ProductSection.prototype.destroy = function () {
    if (this.stickyObserver) this.stickyObserver.disconnect();
    document.body.classList.remove('has-sticky-atc');
  };

  /* ------------------------------------------------------------------
     Customer reviews slider
     ------------------------------------------------------------------ */
  function initTestimonials(root) {
    $$('[data-testimonials]', root).forEach(function (section) {
      if (section._init) return;
      section._init = true;
      var track = $('[data-testimonials-track]', section);
      var cards = $$('[data-testimonial]', section);
      if (!track || !cards.length) return;

      function step() {
        var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        return cards[0].getBoundingClientRect().width + gap;
      }

      var prev = $('[data-testimonials-prev]', section);
      var next = $('[data-testimonials-next]', section);
      if (prev) prev.addEventListener('click', function () {
        if (track.scrollLeft <= 2) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
        else track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      if (!mqSmall.matches && cards.length > 4) {
        window.requestAnimationFrame(function () { track.scrollLeft = step(); });
      }
    });
  }

  /* ------------------------------------------------------------------
     Footer accordions (mobile)
     ------------------------------------------------------------------ */
  function initFooter(root) {
    var blocks = $$('[data-footer-collapsible]', root);
    if (!blocks.length) return;
    function apply() {
      blocks.forEach(function (block) { block.open = !mqSmall.matches; });
    }
    apply();
    if (!initFooter._bound) {
      initFooter._bound = true;
      var handler = function () {
        $$('[data-footer-collapsible]').forEach(function (block) { block.open = !mqSmall.matches; });
      };
      if (mqSmall.addEventListener) mqSmall.addEventListener('change', handler);
      else if (mqSmall.addListener) mqSmall.addListener(handler);
    }
  }

  /* ------------------------------------------------------------------
     Newsletter popup
     ------------------------------------------------------------------ */
  var POPUP_KEY = 'aveline-newsletter-popup';

  function initPopup(root) {
    $$('[data-newsletter-popup]', root).forEach(function (popup) {
      if (popup._init) return;
      popup._init = true;

      function open() {
        popup.classList.add('is-open');
        popup.setAttribute('aria-hidden', 'false');
      }
      function close() {
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        try { window.localStorage.setItem(POPUP_KEY, String(Date.now())); } catch (e) { /* storage unavailable */ }
      }
      popup._open = open;
      popup._close = close;

      popup.addEventListener('click', function (event) {
        if (event.target === popup || event.target.closest('[data-popup-close]')) close();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && popup.classList.contains('is-open')) close();
      });

      if ($('[data-popup-success]', popup)) { open(); return; }
      if (window.Shopify && window.Shopify.designMode) return;
      if (popup.getAttribute('data-enabled') !== 'true') return;

      var days = parseInt(popup.getAttribute('data-frequency'), 10) || 0;
      var delay = (parseInt(popup.getAttribute('data-delay'), 10) || 0) * 1000;
      var last = null;
      try { last = window.localStorage.getItem(POPUP_KEY); } catch (e) { last = null; }
      if (last && days > 0 && Date.now() - parseInt(last, 10) < days * 86400000) return;
      setTimeout(open, delay);
    });
  }

  /* ------------------------------------------------------------------
     Layers rendered inside the (sticky) header are moved to <body> so the
     page overlay can never sit on top of them.
     ------------------------------------------------------------------ */
  function portalize(root) {
    $$('[data-portal]', root).forEach(function (el) {
      if (el.parentElement === document.body) return;
      $$('body > [data-portal]').forEach(function (old) {
        if (old !== el && old.id === el.id) old.remove();
      });
      document.body.appendChild(el);
    });
  }

  /* ------------------------------------------------------------------
     Init + theme editor support
     ------------------------------------------------------------------ */
  function initAll(root) {
    root = root || document;
    initAnnouncements(root);
    initSearch(root);
    initFooter(root);
    initPopup(root);
    initTestimonials(root);
    $$('[data-product-section]', root).forEach(function (el) {
      if (!el._product) el._product = new ProductSection(el);
    });
    portalize(root);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });

  document.addEventListener('shopify:section:unload', function (event) {
    $$('[data-announcement-bar]', event.target).forEach(function (bar) { clearInterval(bar._timer); });
    $$('[data-product-section]', event.target).forEach(function (el) { if (el._product) el._product.destroy(); });
    var sectionId = event.detail && event.detail.sectionId;
    if (sectionId) {
      $$('body > [data-portal]').forEach(function (el) {
        if (el.getAttribute('data-portal-section') === sectionId) el.remove();
      });
    }
    closeLayers(true);
  });

  document.addEventListener('shopify:section:select', function (event) {
    var popup = $('[data-newsletter-popup]', event.target);
    if (popup && popup._open) popup._open();
  });

  document.addEventListener('shopify:section:deselect', function (event) {
    var popup = $('[data-newsletter-popup]', event.target);
    if (popup) {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target;
    var card = block.closest('[data-testimonial]');
    if (card) card.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    if (block.tagName === 'DETAILS') block.open = true;
    var announcement = block.closest('[data-announcement-item]');
    if (announcement) {
      $$('[data-announcement-item]', announcement.parentElement).forEach(function (item) {
        item.classList.toggle('is-active', item === announcement);
      });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
})();
